<template>
  <b-card
      border-variant="secondary"
      align="center"
      style="max-width: 50rem;"
      class="mx-auto"
      no-body>
    <b-card-header header-tag="header" class="p-1 m-1 bg-secondary rounded" role="tab">
      <b-row class="">
          <b-col class="col-sm-auto ml-auto">
            <b-button v-b-toggle.identityInfoCollapse variant="secondary">{{ $t('identity.deviceTable') }}</b-button>
          </b-col>
          <b-col class="col-sm-auto mr-auto">
            <b-form-select v-model="selected_user_id" :options="options">
              <template #first>
                <b-form-select-option value="" disabled>{{$t('identity.selectIdentity')}}</b-form-select-option>
              </template>
              <b-form-select-option :value="user.userId" v-for="user in user_list" :key="user.userId">{{user.userName}}</b-form-select-option>
            </b-form-select>
          </b-col>
      </b-row>
    </b-card-header>
    <b-collapse id="identityInfoCollapse" visible>
      <b-card-body>
        <b-row class="justify-content-sm-center">
          <b-spinner :label="$t('generic.loading')" v-if="is_loading"></b-spinner>
        </b-row>
        <b-row v-if="!identitiesAreAvailable" class="justify-content-sm-center">
          <h6>{{ $t('identity.noIdentities') }}</h6>
        </b-row>
        <b-row v-if="identitiesAreAvailable" class="justify-content-sm-center border-bottom border-light">
          <UnitSecret class="mt-0 mb-2 text-center" :label="$t('unitInfo.secret')"
                    showChange=true :secret="$store.getters.getSelectedUserPassphrase" secretType="IDENTITY"/>
        </b-row>
        <UnitDevices v-if="identitiesAreAvailable" class="mt-2 text-center" type="IDENTITY" :userId="$store.getters.getSelectedUserId" :caption="$t('identity.deviceTable')"/>
      </b-card-body>
    </b-collapse>
  </b-card>
</template>
<script>

import store from "@/store/store";
import UnitDevices from "@/components/UnitDevicesTable";
import UnitSecret from "@/components/UnitSecret";
import userApiService from "@/services/userApiService";

export default {
  name: 'UnitInfo',
  components: {
    UnitDevices,
    UnitSecret
  },
  data () {
    return {
      user_list: [],
      is_loading: true
    }
  },
  computed: {
    identitiesAreAvailable() {
      return !this.is_loading && this.user_list.length > 0
    },
    selected_user_id: {
      get: function() {
        return this.$store.getters.getSelectedUserId
      },
      set: function(newVal) {
        var user = this.user_list.find(u => u.userId === newVal)
        this.$store.dispatch('setSelectedUser', user)
      }
    }
  },
  mounted () {
    this.getAllUsers()
  },
  methods: {
    getAllUsers(){
      if(!store.getters.getIsLoggedIn) {
        return
      }
      this.is_loading = true
      userApiService.getAllUsers(this.type).then(result => {
        if(result?.content && result.content.length > 0) {
          this.user_list = result.content;
          this.selected_user_id = result.content[0].userId
        }
        this.is_loading = false
      })
    },
  }
}
</script>